export default __webpack_public_path__ + "assets/images/bg_desktop2.png";